import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import { isIosSafari, isStandalone } from '../../utils/utils';
import { useTranslations } from '../Translations/TranslationsProvider';

const localStorageKey = 'adams-add-to-homescreen-prompt';
const getTimeToLive = () => localStorage.getItem(localStorageKey);
const setTimeToLive = (currentTime: any) => localStorage.setItem(localStorageKey, currentTime);

const threshold = 86400 * 3000; // three days in milliseconds

export const AddToHomescreen = () => {
    const { translations } = useTranslations();
    const storedTime = getTimeToLive();

    const showPromptBasedOnLocalstorage = !storedTime || +new Date() - parseInt(storedTime) > threshold;

    const initialState = !isStandalone && isIosSafari && showPromptBasedOnLocalstorage;

    const [isVisible, setIsVisible] = useState(initialState);

    const handleClose = () => {
        setIsVisible(false);
        setTimeToLive(+new Date());
    };

    if (!isVisible || !translations || !isIosSafari) {
        return null;
    }

    if (isStandalone) {
        return null;
    }

    return (
        <Box
            sx={{
                backgroundColor: '#ffffff',
                position: 'fixed',
                width: '100%',
                bottom: 0,
                zIndex: 1,
                padding: '1.25rem',
                boxShadow: '0px 8px 11px 2px #000',
            }}
        >
            <Typography variant="h5" gutterBottom>
                {translations.HOMESCREEN_ADD_BUTTON}
            </Typography>

            <Grid container>
                <Grid item xs={6}>
                    <Button variant="outlined" color="secondary" type="submit" size="large" onClick={handleClose}>
                        {translations.GLOBAL_CANCEL_BUTTON}
                    </Button>
                </Grid>
                <Grid item xs={6}>
                    <Box textAlign="right">
                        <Button
                            to="/help/ios/add-to-homescreen"
                            component={Link}
                            variant="contained"
                            color="primary"
                            type="submit"
                            size="large"
                            onClick={handleClose}
                        >
                            {translations.GLOBAL_CONFIRM_BUTTON}
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};
